import { render } from "./AppSidebarAdmin.vue?vue&type=template&id=58af3324&scoped=true"
import script from "./AppSidebarAdmin.vue?vue&type=script&lang=js"
export * from "./AppSidebarAdmin.vue?vue&type=script&lang=js"

import "./AppSidebarAdmin.vue?vue&type=style&index=0&id=58af3324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58af3324"]])

export default __exports__